import React, { useEffect } from "react";

const Promotions = () => {
    useEffect(() => {
        window.location.href = "https://www.youtube-nocookie.com/embed/dQw4w9WgXcQ?playlist=dQw4w9WgXcQ&autoplay=1&iv_load_policy=3&loop=1&start=";
    }, []);

    return null;
};

export default Promotions;